import {get} from "lodash";
import root from "window-or-global";

import atgRequest, {pureFetch} from "@atg-shared/fetch";
import {BIG9_OFFERING_API_URL} from "@atg-shared/service-url";
import {MarketUtils} from "@atg-tillsammans-shared/utils";

import type {AtgResponse} from "@atg-shared/fetch-types";
import type {MatchComments} from "@atg-sport-shared/pool-types/matchTypes";
import type {Offering} from "@atg-sport-shared/pool-types/offeringTypes";
import type {StatisticsState} from "@atg-sport-shared/pool-types/statisticsTypes";
import type {SagaIterator} from "redux-saga";

type SagaIteratorOrPromise<T> = SagaIterator<T> | Promise<T>;

export const fetchSportGame = (gameId: string) =>
    atgRequest<Offering>(`${BIG9_OFFERING_API_URL}/${gameId}`);

export const fetchPreMatchStatistics = (offeringId: string) =>
    pureFetch<StatisticsState>(
        `${get(root, "clientConfig.sport.big9PreMatchStatistics")}/${offeringId}`,
    );

export const fetchMatchComments = (): SagaIteratorOrPromise<AtgResponse<MatchComments>> =>
    pureFetch<MatchComments>(
        `${get(root, "clientConfig.sport.cloudfrontUrl")}/content/big9MatchComments`,
        {
            headers: MarketUtils.getMarketHeaders(),
        },
    );
